import { isEmpty, isNull } from 'lodash'
import socketIOClient from 'socket.io-client'
import { SET_ANNOUNCEMENT, SET_CONNECT_LOBBY, SET_LOBBY_LIST, SHOW_POPUP } from '../redux/actions/type'
import { deleteCookie, getCookie, setCookie } from './Auth'
import { setHttpErrObj } from './HttpClient'
import _ from 'lodash'


export const authenRocketChat = (jwt) => {
    return fetch(`${window._env_.rocketChatAPIUrl}api/v1/auth`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${jwt}`,
            'Content-Type': 'application/json'
        }
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                //error case via APIs.
                if (window._env_.APP_ENV === 'development') {
                    throw new Error(`Status bad request: ${window._env_.rocketChatAPIUrl}`);
                } else {
                    const errorObj = setHttpErrObj("authenRocketChat", "status bad request", "HTTP Client POST: status bad request " + response.url)
                    setCookie('error', JSON.stringify(errorObj), { period: 'minutes', duration: 1 })
                    window.location.href = `${window._env_.vRoomUrl}/portal/error?errorCode=${response.status}&message=error_text_1&setLog=true`
                }
            }
        })
        .then(json => {
            return json
        })
        .catch(err => console.error('authenRocketChat', err))
}

export const anonymousRocketChat = (reqObj) => {
    return fetch(`${window._env_.rocketChatAPIUrl}api/v1/auth`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(reqObj)
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                //error case via APIs.
                if (window._env_.APP_ENV === 'development') {
                    throw new Error(`Status bad request: ${window._env_.rocketChatAPIUrl}`);
                } else {
                    const errorObj = setHttpErrObj("anonymousRocketChat", "status bad request", "HTTP Client POST: status bad request " + response.url)
                    setCookie('error', JSON.stringify(errorObj), { period: 'minutes', duration: 1 })
                    window.location.href = `${window._env_.vRoomUrl}/portal/error?errorCode=${response.status}&message=error_text_1&setLog=true`
                }
            }
        })
        .then(json => {
            return json
        })
        .catch(err => console.error('anonymousRocketChat', err))
}

export const setRocketStore = (rocketObj) => {
    const { name, chatUserID, chatUserToken } = rocketObj
    // setCookie('rocketChatInfo', JSON.stringify({ name, chatUserID, chatUserToken }), { period: 'hours', duration: 1 })
    const key = 'rocketChatInfo';
    deleteCookie(key)
    localStorage.removeItem('rocketChatLogoutInfo')
    const value = JSON.stringify({ name: encodeURIComponent(name), chatUserID, chatUserToken });
    const myDate = new Date();
    myDate.setHours(myDate.getFullYear() + 1);
    document.cookie = key + "=" + value + ";expires=" + myDate
        + ";domain=.truevirtualworld.com;path=/";
    localStorage.setItem('rocketChatLogoutInfo', JSON.stringify({ chatUserID, chatUserToken }))
}

export const setLobbyStore = (lobbyObj) => {
    deleteCookie('lobbyRoomInfo')
    const { _id, name, roomName, reservationId } = lobbyObj
    setCookie('lobbyRoomInfo', JSON.stringify({ name, _id, roomName, reservationId }), { period: 'hours', duration: 1 })
}

export const setChatID = (rocketObj) => {
    if (!_.isUndefined(rocketObj) || !_.isNull(rocketObj)) {
        const { chatUserID, chatUserToken, chatUserName } = rocketObj
        if (chatUserID !== undefined || chatUserID !== null) {
            localStorage.setItem('setChatID', JSON.stringify({ chatUserID }))
        }
        if (chatUserToken !== undefined || chatUserToken !== null) {
            localStorage.setItem('chatUserToken', JSON.stringify({ chatUserToken }))
        }
        if (chatUserName !== undefined || chatUserName !== null) {
            localStorage.setItem('chatUserName', JSON.stringify({ chatUserName }))
        }
        localStorage.setItem('DataManager', JSON.stringify(rocketObj))
    }


}

export const setLobbyManager = (name, dispatch, chatID, userID) => {
    setTimeout(() => {
        const socket = socketIOClient(`${window._env_.lobbyAPIUrl}lobby-manager`, {
            query: {
                vtoken: localStorage.getItem('vtoken'),
                name: name.roomName
            }
        });
        socket.on('onConnect', function (data) {
            if (data.code !== 200)
                window.location.href = `${window._env_.vRoomUrl}/portal/notFound`
            console.log('onConnect', data)
        });
        socket.on('userList', function (data) {
            dispatch({
                type: SET_LOBBY_LIST,
                payload: {
                    lobbyLists: data
                }
            })
            console.log("userList", data)
        });
        socket.emit('setChatID', chatID, function (data) {
            console.log('setChatID', data);
        });
        if (userID !== undefined) {
            socket.emit('chat', userID, function (data) {
                console.log('chat', data);
                //localStorage.setItem('chat', data.data.chatRoomId)
            });
        }

    }, 1000);
}

export const setAuthLobby = (rocketObj, dispatch) => {
    let newVtoken = null
    const { chatUserID, name, roomName, reservationId, chatRoomId, vtoken } = rocketObj
    const socket = socketIOClient(`${window._env_.lobbyAPIUrl}lobby`, {
        query: {
            roomName: encodeURIComponent(roomName),
            chatUserId: chatUserID,
            chatRoomName: `${reservationId}_${chatUserID}`,
            chatRoomId: chatRoomId,
            intent: "conference",
            vtoken,
            name: decodeURIComponent(name)
        }
    });
    socket.on('onConnect', function (data) {
        console.log('onConnect', data)
    });
    socket.on('setToken', function (data) {
        console.log("setToken", data)
        newVtoken = data.vtoken
    });
    socket.on('updateState', function (data) {
        console.log("updateState", data)
        const { intentionStatus } = data

        if (intentionStatus === 1) {
            let tempVtoken = vtoken
            if (!isNull(newVtoken)) {
                tempVtoken = newVtoken
            }
            window.location.href = `${window._env_.vRoomUrl}/${roomName}?jwt=${tempVtoken}`
        }

        if (intentionStatus === 2) {
            dispatch({
                type: SHOW_POPUP,
                payload: {
                    isShow: true,
                    textBody: 'popupInfo.reject',
                    action: `${window._env_.vRoomUrl}/portal`,
                    textHeader: 'popupInfo.reject_header'
                }
            })
            dispatch({
                type: SET_CONNECT_LOBBY,
                payload: {
                    connecting: false
                }
            })
        }
    });
    socket.on('setProfile', function (data) {
        console.log("setProfile", data)
        setOverridename({ ...data, chatUserID }, 'AuthRucket')
    });
    socket.on('modEnterRoom', function (data) {
        console.log("modEnterRoom", data)
        dispatch({
            type: SET_CONNECT_LOBBY,
            payload: {
                connecting: true
            }
        })
    });
    socket.on('announcement', function (data) {
        dispatch({
            type: SET_ANNOUNCEMENT,
            payload: {
                announcement: data
            }
        })
    });
    socket.on('roomExpire', function () {
        dispatch({
            type: SHOW_POPUP,
            payload: {
                isShow: true,
                textBody: 'popupInfo.body',
                action: `${window._env_.vRoomUrl}/portal`
            }
        })
    });
}

export const setAnonymousLobby = (rocketObj, dispatch) => {
    let vToken = null
    const { chatUserID, name, roomName, reservationId, chatRoomId, anonymousID } = rocketObj
    const socket = socketIOClient(`${window._env_.lobbyAPIUrl}lobby`, {
        query: {
            roomName: encodeURIComponent(roomName),
            chatUserId: chatUserID,
            chatRoomName: `${reservationId}_${chatUserID}`,
            chatRoomId: chatRoomId,
            intent: "conference",
            anonymousID,
            anonymousName: decodeURIComponent(name)
        }
    });
    socket.on('onConnect', function (data) {
        console.log('onConnect', data)
    });
    socket.on('setToken', function (data) {
        console.log("setToken", data)
        vToken = data.vtoken
    });
    socket.on('updateState', function (data) {
        console.log("updateState", data)
        const { intentionStatus } = data
        if (intentionStatus === 1 && !isNull(vToken)) {
            window.location.href = `${window._env_.vRoomUrl}/${roomName}?jwt=${vToken}`
        }
        if (intentionStatus === 2) {
            dispatch({
                type: SHOW_POPUP,
                payload: {
                    isShow: true,
                    textBody: 'popupInfo.reject',
                    action: `${window._env_.vRoomUrl}/portal`,
                    textHeader: 'popupInfo.reject_header'
                }
            })
            dispatch({
                type: SET_CONNECT_LOBBY,
                payload: {
                    connecting: false
                }
            })
        }
    });
    socket.on('setProfile', function (data) {
        console.log("setProfile", data)
        setOverridename({ ...data, chatUserID }, 'AnonymousRocket')
    });
    socket.on('modEnterRoom', function (data) {
        console.log("modEnterRoom", data)
        dispatch({
            type: SET_CONNECT_LOBBY,
            payload: {
                connecting: true
            }
        })
    });
    socket.on('announcement', function (data) {
        dispatch({
            type: SET_ANNOUNCEMENT,
            payload: {
                announcement: data
            }
        })
    });
    socket.on('roomExpire', function () {
        dispatch({
            type: SHOW_POPUP,
            payload: {
                isShow: true,
                textBody: 'popupInfo.body',
                action: `${window._env_.vRoomUrl}/portal`
            }
        })
    });
}

export const getAuthMethod = (roomName) => {
    return fetch(`${window._env_.reservation}api/v1/public/reservations/current?name=${roomName}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        },
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                if (response.status === 404) {
                    // roomName not found
                    window.location.href = `${window._env_.vRoomUrl}/portal/notFound`
                } else {
                    //error case via APIs.
                    if (window._env_.APP_ENV === 'development') {
                        throw new Error(`Status bad request: ${window._env_.reservation}`);
                    } else {
                        const errorObj = setHttpErrObj("getAuthMethod", "status bad request", "HTTP Client GET: status bad request " + response.url)
                        setCookie('error', JSON.stringify(errorObj), { period: 'minutes', duration: 1 })
                        window.location.href = `${window._env_.vRoomUrl}/portal/error?errorCode=${response.status}&message=error_text_1&setLog=true`
                    }
                }
            }
        })
        .then(json => {
            return json
        })
        .catch(err => console.error('getAuthMethod', err))
}

export const createRocketChat = (createObj) => {
    return fetch(`${window._env_.rocketChatAPIUrl}api/v1/room/group`, {
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(createObj)
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                //error case via APIs.
                if (window._env_.APP_ENV === 'development') {
                    throw new Error(`Status bad request: ${window._env_.rocketChatAPIUrl}`);
                } else {
                    const errorObj = setHttpErrObj("getAuthMethod", "status bad request", "HTTP Client GET: status bad request " + response.url)
                    setCookie('error', JSON.stringify(errorObj), { period: 'minutes', duration: 1 })
                    window.location.href = `${window._env_.vRoomUrl}/portal/error?errorCode=${response.status}&message=error_text_1&setLog=true`
                }
            }
        })
        .then(json => {
            return json
        })
        .catch(err => console.error('createRocketChat', err))
}

export const setProfile = (roomName, name, id) => {
    const socket = socketIOClient(`${window._env_.lobbyAPIUrl}lobby-manager`, {
        query: {
            vtoken: localStorage.getItem('vtoken'),
            name: roomName.roomName
        }
    });
    socket.emit('setProfile', { name, id }, function (data) {
        console.log('setProfile', data);
    });
}

export const approveUser = (roomName, id) => {
    console.log('test');
    const socket = socketIOClient(`${window._env_.lobbyAPIUrl}lobby-manager`, {
        query: {
            vtoken: localStorage.getItem('vtoken'),
            name: roomName
        }
    });
    socket.emit('approve', { id, vtoken: localStorage.getItem('vtoken') }, function (data) {
        console.log('chat', data);
    })
}

export const setConnectChatID = (roomName, chatID) => {
    const socket = socketIOClient(`${window._env_.lobbyAPIUrl}lobby-manager`, {
        query: {
            vtoken: localStorage.getItem('vtoken'),
            name: roomName.roomName
        }
    });
    socket.emit('setChatID', chatID, function (data) {
        console.log('setChatID::', data);
    });
}

export const setConnectChat = (roomName, chatID, userID) => {
    const socket = socketIOClient(`${window._env_.lobbyAPIUrl}lobby-manager`, {
        query: {
            vtoken: localStorage.getItem('vtoken'),
            name: roomName.roomName
        }
    });

    socket.emit('setChatID', chatID, function (data) {
        console.log('setChatID', data);
    });
    socket.emit('chat', userID, function (data) {
        console.log('chat', data);
    });

}

export const setOverridename = (obj, funcName) => {
    const { overrideName, chatUserID } = obj
    return fetch(`${window._env_.rocketChatAPIUrl}api/v1/user`, {
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({ name: overrideName, chatUserID })
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            } else {
                throw new Error(`Can't connect to ${window._env_.rocketChatAPIUrl}`);
            }
        })
        .then(json => {
            const rocketChatInfo = getCookie('rocketChatInfo') ? JSON.parse(getCookie('rocketChatInfo')) : {}
            const anonymousInfo = localStorage.getItem('anonymousInfo') ? JSON.parse(localStorage.getItem('anonymousInfo')) : {}
            const { success } = json
            if (!isEmpty(rocketChatInfo) && success) {
                setRocketStore({ ...rocketChatInfo, name: overrideName })
            }
            if (!isEmpty(anonymousInfo) && success && funcName === 'AnonymousRocket') {
                localStorage.setItem('anonymousInfo', JSON.stringify({ ...anonymousInfo, name: encodeURIComponent(overrideName) }))
            }
            return json
        })
        .catch(err => console.error('setOverridename', err))
}

export const destroyRocketChatInfo = () => {
    const rocketChatInfo = localStorage.getItem('rocketChatLogoutInfo') ? JSON.parse(localStorage.getItem('rocketChatLogoutInfo')) : {}
    deleteCookie('rocketChatInfo')
    localStorage.removeItem('rocketChatLogoutInfo')
    if (!isEmpty(rocketChatInfo)) {
        const { chatUserID, chatUserToken } = rocketChatInfo
        fetch(`${window._env_.rocketChatIFrameUrl}api/v1/logout`, {
            headers: {
                'X-Auth-Token': chatUserToken,
                'X-User-Id': chatUserID
            },
            method: 'POST',
        })
            .then(response => {
                if (response.ok) {
                    return response.json()
                }
            })
            .then(json => {
                return json
            })
            .catch(err => console.error('destroyRocketChatInfo', err))
    }
}



export const roomUsersCount = (auth, userid, roomID) => {
    return fetch(`${window._env_.realtimeRocket}/api/v1/rooms.info?roomId=${roomID}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Auth-Token': auth,
            'X-User-Id': userid
        },
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            }
        })
        .then(json => {
            return json
        })
        .catch(err => console.error('get room users count', err))
}

export const ChangeNameMod = (auth, userid, newName) => {

    return fetch("https://rocketchat-ts.truevirtualworld.com/api/v1/users.update", {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'X-Auth-Token': auth,
            'X-User-Id': userid
        },
        body: JSON.stringify(newName)
    })
        .then(response => {
            if (response.ok) {
                return response.json()
            }
        })
        .then(json => {
            return json
        })
        .catch(err => console.error('get room users count', err))
}